import React, { Component } from "react"
import { CountdownCircleTimer } from "react-countdown-circle-timer"

class Timer extends Component {

    constructor(props) {
        super(props)

        this.state = {
            duration: 0,
            startTime: 0,
            key: 0
        }
    }

    /* Start Action */
    start = (duration = 10) => {

        const d = parseInt(duration, 10)

        // duration должен быть > 0
        if (!Number.isFinite(d) || d <= 0) {
            this.setState({ duration: 0 })
            return
        }

        this.setState(prev => ({
            duration: d,
            startTime: Date.now(),
            key: prev.key + 1
        }))
    }

    /* Stop Action (если нужно) */
    stop = () => {
        this.setState(prev => ({ duration: 0, key: prev.key + 1 }))
    }

    /* Get Remaining Time */
    getRemainingTime = () => {

        const { startTime, duration } = this.state

        if (!duration || duration <= 0 || !startTime) return 0

        const elapsed = Math.floor((Date.now() - startTime) / 1000)
        const remaining = Math.max(0, duration - elapsed)

        return remaining
    }

    render = () => {

        const { duration, key } = this.state

        // если duration=0 — просто не показываем таймер (и не рендерим компонент библиотеки)
        if (!duration || duration <= 0) {
            return <div className="mpb--timer hidden" />
        }

        const initialRemainingTime = this.getRemainingTime()

        return (
            <div className={`mpb--timer ${duration > 0 ? "visible" : "hidden"}`}>
                <CountdownCircleTimer
                    key={`${key}`}
                    isPlaying
                    duration={duration}
                    initialRemainingTime={initialRemainingTime}
                    colors={["#448b03", "#dba504", "#a20101"]}
                    colorsTime={[duration, Math.ceil(duration / 2), 0]}
                    size={90}
                    strokeWidth={12}
                    trailColor="rgba(0, 0, 0, 0.2)"
                    onComplete={() => {
                        // после завершения скрываем
                        this.stop()
                        return { shouldRepeat: false }
                    }}
                >
                    {({ remainingTime }) => <div className="mpb--timer-text">{remainingTime}</div>}
                </CountdownCircleTimer>
            </div>
        )
    }
}

export default Timer